import React from "react";
import { PETTY_CASH_VOUCHER_STATUS_LABEL } from "../pettyCashStatusMaps";

// Suffix appended to the status inside ONE pill. Two separate badges wrapped onto a
// second line on narrower rows, which made the list's row heights ragged - and read as
// two competing labels rather than one fact about the voucher.
const RECEIPT_SUFFIX = {
  PENDING: "No receipt",
  REQUIRED: "Receipt due",
  ATTACHED: "Receipt",
};

const STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-lineinfo",
  PAID: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};

/**
 * Voucher status and receipt state as a single badge.
 *
 * A paid voucher that still owes a receipt takes the danger colour, because that is
 * the exception worth spotting when scanning a list - everything else keeps its normal
 * status colour. `white-space: nowrap` keeps it on one line so every row is the same
 * height.
 */
const VoucherStatusChip = ({ status, receiptStatus }) => {
  const suffix = RECEIPT_SUFFIX[receiptStatus];
  const label = PETTY_CASH_VOUCHER_STATUS_LABEL[status] || status;
  const cls = receiptStatus === "PENDING" ? "badge-linedanger" : STATUS_CLASS[status] || "badge-linedark";

  return (
    <span className={`badge ${cls} text-nowrap`}>
      {label}
      {suffix ? ` · ${suffix}` : ""}
    </span>
  );
};

export default VoucherStatusChip;
